import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-themepark',
  templateUrl: './themepark.component.html',
  styleUrls: ['./themepark.component.css']
})
export class ThemeparkComponent implements OnInit {

  constructor() { }

  Entrance = [
    {
      img: '1.png'
    },
    {
      img: '2.png'
    },
    {
      img: '3.png'
    },
    {
      img: '4.png'
    },
  ];

  Coaster = [
    {
      img: '5.png'
    },
    {
      img: '6.png'
    },
  ];

  Water = [
    {
      img: '7.png'
    },
    {
      img: '8.png'
    },
    {
      img: '9.png'
    },
    {
      img: '10.png'
    },
    {
      img: '11.png'
    },
    {
      img: '12.png'
    },
  ];

  Rides = [
    {
      img: '13.png'
    },
    {
      img: '14.png'
    },
    {
      img: '15.png'
    },
  ];

  Details = [
    {
      img: '16.png'
    },
    {
      img: '17.png'
    },
    {
      img: '18.png'
    },
    {
      img: '19.png'
    },
  ];

  Datapack = [
    {
      img: '20.png'
    },
    {
      img: '21.png'
    },
  ];

  Night = [
    {
      img: 'n1.png'
    },
    {
      img: 'n2.png'
    },
    {
      img: 'n3.png'
    },
    {
      img: 'n4.png'
    },
    {
      img: 'n5.png'
    },
  ];

  ngOnInit(): void {
  }
}
